export default "__VITE_ASSET__nsqhaLuS__"